import * as React from "react";

function SvgPrev(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      width="1em"
      viewBox="0 0 16 16"
      className="prev_svg__Svg-ulyrgf-0 prev_svg__hJgLcF"
      {...props}
    >
      <path d="M13 2.5L5 7.119V3H3v10h2V8.881l8 4.619z" />
    </svg>
  );
}

export default SvgPrev;
